/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import AddCircleIcon from "@mui/icons-material/AddCircle";
import CancelIcon from "@mui/icons-material/Clear";
import { Field, FieldArray, Form, Formik, useFormik } from "formik";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import * as Yup from "yup";
// Dashboard components
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import MDButton from "components/MDButton";
import MDCard from "components/MDCard";

// Dashboard standardized components
import CreateButton from "components/standardized-components/CreateButton";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { ToastContainer, toast } from "react-toastify";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Modal from "@mui/material/Modal";

import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  createBomForPo,
  createDynamicColumn,
  deleteBom,
  deleteFgForBom,
  editBom,
  getAssemblyByAssemblyType,
  getAssemblyMaster,
  getAssemblyTypes,
  getBomForPo,
  getDownloadBomData,
  getDynamicColumn,
  getFgCode,
  getFgCodeByAssemblyType,
  getItemMaster,
  getItemsForBom,
  getOperationsByPo,
  getPoListingWithoutPagination,
  getStationsByAssemblyIdForBom,
  getSubModulesByRoleId,
  uploadForBomForPo,
} from "../../../store";
// Cookies
import Cookies from "universal-cookie";

// config file
import { Backdrop, CircularProgress } from "@mui/material";
import MDInput from "components/MDInput";
import DeleteButton from "components/standardized-components/DeleteButton";
import DownloadButton from "components/standardized-components/DownloadButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import ViewButton from "components/standardized-components/ViewButton";
import { addMinutes, format } from "date-fns";
import { CSVLink } from "react-csv";
import TextError from "utils/TextError";
import Config from "../../../config/index";

const cookies = new Cookies();

const desLength = Config.descriptionLength;

const styleForView = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1100,
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForView2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1100,
  height: "auto", // Set height relative to viewport height (80% of viewport height)
  maxHeight: "90vh", // Set a maximum height
  overflowY: "auto", // Enable vertical scrolling if content overflows
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};
const styleForCreateBom = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 1120 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 3,
  overflow: "scroll",
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};
const BOMW = ({
  getBomForPo,
  getBomForPoReducer,

  editBom,
  createBomForPo,
  getSubModulesByRoleIdReducer,
  getSubModulesByRoleId,
  getItemsForBom,

  itemMaster,

  getItemForBomReducer,
  getItemMaster,

  uploadForBomForPo,

  deleteBom,
  deleteFgForBom,
  getOperationsByPo,
  getOperationsByPoReducer,
  getPoListingWithoutPagination,
  getPoListingWithoutPaginationReducer,
  getDynamicColumn,
  createDynamicColumn,

  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let userId = loginDetails.data.userId;

  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  const subModuleId = "bfb048ba-31e3-4f37-864d-f1f13091de17";

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  useEffect(() => {
    getItemMaster(jwtToken);
  }, []);

  const [selectedAssemblyTypeForHeader, setSelectedAssemblyTypeForHeader] =
    useState("");

  useEffect(() => {
    getAssemblyMaster(jwtToken);
  }, []);
  const [assemblyTypesOptionsForHeader, setAssemblyTypesOptionsForHeader] =
    useState([]);

  useEffect(() => {
    getAssemblyByAssemblyType(selectedAssemblyTypeForHeader?.value, jwtToken);
  }, [selectedAssemblyTypeForHeader]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let bomModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "bfb048ba-31e3-4f37-864d-f1f13091de17",
  );

  let createBomForPoAccess = bomModule
    ? bomModule.actionId.includes("588fd113-9f72-4b93-8ea6-fad75720d829")
    : null;

  let uploadBom = bomModule
    ? bomModule.actionId.includes("d61e4c0b-dd64-4649-9d13-94d658a8fc4b")
    : null;
  let downloadBom = bomModule
    ? bomModule.actionId.includes("4dbec933-5b9f-4342-a823-231b66634c14")
    : null;
  let deleteStationMapping = bomModule ? bomModule.actionId.includes("") : null;
  let deleteAccess = bomModule
    ? bomModule.actionId.includes("db796df9-4c06-4c55-8b5d-d88ab6f121b4")
    : null;
  let addAccess = bomModule
    ? bomModule.actionId.includes("c5bd9d66-01a1-452b-ab2f-7dcddeaa4679")
    : null;
  let viewBom = bomModule
    ? bomModule.actionId.includes("523c7c21-55b1-434b-9943-3e20995722ec")
    : null;
  let viewStationMapping = bomModule
    ? bomModule.actionId.includes("a04ddb63-f977-4e69-926b-60a916b4c831")
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const [state, setState] = useState({
    columns: [
      { Header: "PO Number", accessor: "poNumber" },
      { Header: "operation Code", accessor: "operationCode" },
      { Header: "itemCode", accessor: "itemCode" },
      { Header: "quantity", accessor: "qty" },
      // {
      //   Header: "Created Date",

      //   accessor: "cd",
      //   align: "left",
      //   searchType: "date",
      //   Cell: ({ value }) => {
      //     return value
      //       ? format(
      //           addMinutes(
      //             new Date(value),
      //             new Date(value)?.getTimezoneOffset()
      //           ),
      //           "dd/MM/yyyy hh:mm aaa"
      //         )
      //       : "";
      //   },
      //   cannotSort: true,
      // },
      // {
      //   Header: "Action",
      //   accessor: "action",
      //   cannotSearch: true,
      //   cannotSort: true,
      // },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const [singleFgDataForUpdate, setSingleFgDataForUpdate] = useState({});

  const handleOpenUpdateModal = (singleData) => {
    setSingleFgDataForUpdate(singleData);
    setOpenUpdateModal(true);
  };

  const handleCloseModal = () => {
    setOpenUpdateModal(false);
    formikForUpdate.setErrors({});
    formikForUpdate.setValues(initialValueForUpdate);
  };

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
  const [errorMsgForCreate, setErrorMsgForCreate] = useState("");
  const [fgModelCode, setFgModelCode] = useState("");

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    reqQty: singleFgDataForUpdate.requiredQty,
  };
  const onSubmitForUpdate = async (values) => {
    let payload = {
      requiredQty: values.reqQty,
      stationId: singleFgDataForUpdate.stationId,
      fgModelId: singleFgDataForUpdate.fgModelId,
      itemId: singleFgDataForUpdate.itemId,
      bomId: singleFgDataForUpdate.bomId,
      userId: userId,
    };
    let res = await editBom(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getBomForPo(pageNo, rowsPerPage, searchObject, jwtToken);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
    }
  };

  const validationSchemaForBom = Yup.object({
    itemsForBom: Yup.array().of(
      Yup.object({
        qty: Yup.number()
          .min(0, "Quantity cannot be negative")
          .required("Quantity is required"),
      }),
    ),
  });
  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });
  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemCode,
        uom: item.uom,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);
  const [itemCodeBomOptions, setItemCodeBomOptions] = useState([]);

  useEffect(() => {
    let tempListOfBinTypesOptions = [];
    let data = getPoListingWithoutPaginationReducer.poListing.data
      ? getPoListingWithoutPaginationReducer.poListing.data
      : [];
    data.map((bin) => {
      tempListOfBinTypesOptions.push({
        label: bin.poNumber,
        value: bin.poId,
      });
    });
    setAssemblyTypesOptionsForHeader(tempListOfBinTypesOptions);
  }, [getPoListingWithoutPaginationReducer]);

  useEffect(() => {
    let tempItemCodeBomOptions = [];
    let data = getItemForBomReducer.items ? getItemForBomReducer.items : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeBomOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
      });
    });
    setItemCodeBomOptions(tempItemCodeBomOptions);
  }, [getItemForBomReducer]);

  const [selectedFgCode, setSelectedFgCode] = useState("");
  const handleFgCodeChange = (selectedActivity) => {
    setSelectedFgCode(selectedActivity);
  };
  const handleAssemblyTypeForHeaderChange = (selectedActivity) => {
    setSelectedAssemblyTypeForHeader(selectedActivity);
  };

  const [itemsForBomLength, setItemsForBomLength] = useState("");

  const [isSuccessForCreateBOM, setIsSuccessForCreateBOM] = useState(false);
  const [isErrorForCreateBOM, setIsErrorForCreateBOM] = useState(false);

  useEffect(() => {
    if (isSuccessForCreateBOM) {
      setTimeout(() => {
        setIsSuccessForCreateBOM(false);
      }, 3000);
    }
  }, [isSuccessForCreateBOM]);

  const [stationsOptions, setStationsOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getOperationsByPoReducer.operations.data
      ? getOperationsByPoReducer.operations.data
      : [];
    data.map((activity) => {
      tempLevelOptions.push({
        label: activity.operationCode,
        value: activity.operationId,
      });
    });
    setStationsOptions(tempLevelOptions);
  }, [getOperationsByPoReducer]);

  console.log(getOperationsByPoReducer);

  const [selectedAssembly, setAssembly] = useState("");
  const [fgCodeForFlag, setFgCodeForFlag] = useState("");
  const [selectedAssemblyType, setAssemblyType] = useState("");
  const [fgModelId, setFgModelId] = useState("");
  const [selectedAssemblyId, setAssemblyId] = useState("");

  useEffect(() => {
    if (selectedAssemblyId) {
      getStationsByAssemblyIdForBom(selectedAssemblyId, jwtToken);
    }
  }, [selectedAssemblyId, jwtToken]);

  const handleAssemblyChange = (selectedOption) => {
    setAssembly(selectedOption);
  };

  useEffect(() => {
    getFgCodeByAssemblyType(selectedAssemblyTypeForHeader?.value, jwtToken);
  }, [selectedAssemblyTypeForHeader]);
  const [fgCodeOptions, setFgCodeOptions] = useState([]);

  const [assemblyOptions, setAssemblyOptions] = useState([]);

  useEffect(() => {
    if (isErrorForCreateBOM) {
      setTimeout(() => {
        setIsErrorForCreateBOM(false);
      }, 3000);
    }
  }, [isErrorForCreateBOM]);

  useEffect(() => {
    getBomForPo(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [pageNo, rowsPerPage, searchObject]);

  useEffect(() => {
    getPoListingWithoutPagination(jwtToken);
  }, []);
  useEffect(() => {
    getDownloadBomData(jwtToken);
  }, []);

  const [fgCode, setFgCode] = useState("");

  const [assemblyIdForBom, setAssemblyIdForBom] = useState("");

  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(true);
  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getBomForPoReducer.bom.data ? getBomForPoReducer.bom.data : [];
    setPaginationObj(getBomForPoReducer?.bom?.pagination);

    setLoading(getBomForPoReducer.loading);
    data &&
      data.map((finishedGoods) => {
        const formatDate = new Date(finishedGoods.cd && finishedGoods.cd);

        let des = finishedGoods?.description;
        let len = desLength;
        const time = new Date(finishedGoods.cd && finishedGoods.cd);
        const finishedGoodsObject = {
          poId: finishedGoods.poId,
          poNumber: finishedGoods.poNumber,
          operationCode: finishedGoods.operationCode,

          itemCode: finishedGoods.itemCode,
          stationCode: finishedGoods.stationCode,
          requiredQty: finishedGoods.requiredQty,
          description: des ? des.substring(0, len) : "",
          qty: `${finishedGoods.qty}`,
          uom: `${finishedGoods.uom}`,
          // createdDate: format(
          //   addMinutes(formatDate, formatDate?.getTimezoneOffset()),
          //   "dd/MM/yyyy hh:mm aaa"
          // ),
          cd: finishedGoods && finishedGoods.cd,
          action: (
            <>
              {viewStationMapping && (
                <ViewButton
                  tooltip="View"
                  // disabled={!viewVins}
                  variant="gradient"
                  color="info"
                  iconOnly
                  type="button"
                  onClick={() => {
                    setFgCode(finishedGoods.fgModelId);
                    setAssemblyIdForBom(finishedGoods.assemblyId);
                    setFgModelCode(finishedGoods.fgModelCode);

                    handleOpenViewItemModal(finishedGoods);
                  }}
                  style={{ marginRight: "5px" }}
                >
                  <Icon>visibility</Icon>
                </ViewButton>
              )}
              {addAccess && (
                <CreateButton
                  tooltip="Add Station"
                  variant="gradient"
                  color="success"
                  iconOnly
                  type="button"
                  onClick={() => {
                    setAssemblyId(finishedGoods.assemblyId);
                    setFgModelId(finishedGoods.fgModelId);
                    setAssembly(finishedGoods.assembly);
                    setAssemblyType(finishedGoods.assemblyType);
                    setFgCodeForFlag(finishedGoods.fgModelCode);
                    handleOpenAddModal(finishedGoods);
                    getStationsByAssemblyIdForBom(
                      finishedGoods.assemblyId,
                      jwtToken,
                    );
                  }}
                  style={{ marginRight: "5px", backgroundColor: "#39AD48" }}
                >
                  <Icon>edit_sharp</Icon>
                </CreateButton>
              )}
              {deleteAccess && (
                <DeleteButton
                  tooltip="Delete"
                  variant="gradient"
                  color="error"
                  iconOnly
                  type="button"
                  style={{ marginRight: "5px" }}
                  onClick={() => handleOpenFgDeleteModal(finishedGoods)}
                >
                  <Icon>delete</Icon>
                </DeleteButton>
              )}
            </>
          ),
        };
        tempFinishedGoods.push(finishedGoodsObject);
      });
    viewBom && setState({ ...state, rows: tempFinishedGoods });
  }, [getBomForPoReducer]);

  const [isFlagMode, setIsFlagMode] = useState(false);
  const [viewModal, setOpenViewModal] = useState(false);

  const handleOpenViewItemModal = (finishedGoods) => {
    setTimeout(() => {
      setOpenViewModal(true);
    }, 200);
  };
  const handleCloseViewModal = () => {
    setOpenViewModal(false);
  };
  const [vinTable, setViewTable] = useState({
    columns: [
      { Header: "Station", accessor: "station" },
      { Header: "Station Order", accessor: "stationOrder" },
      { Header: "Item Code", accessor: "itemCode" },
      { Header: "Item Description", accessor: "itemDescription" },
      { Header: "Required QTY", accessor: "reqQty" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns: itemColumns, rows: itemRows } = vinTable;

  const formatDate = (date) => {
    if (!date) return ""; // Return an empty string if date is undefined or null
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(date).toLocaleDateString("en-US", options);
    return formattedDate;
  };

  // Get the data for download
  // let dataForDownload = getDownloadBomDataReducer.BomData
  //   ? getDownloadBomDataReducer.BomData
  //   : [];

  // Ensure createdDate is formatted correctly
  // dataForDownload = dataForDownload.map(item => {
  //   return {
  //     ...item,
  //     createdDateOuter: item.cd ? formatDate(item.cd) : 'No Date', // Format the createdDate
  //   };
  // });

  const [dataForView, setDataForView] = useState([]);

  // useEffect(() => {
  //   let tempVin = [];
  //   let data = getItemMasterReducer.items
  //     ? getItemMasterReducer.items
  //     : [];

  //   setLoading2(getItemMasterReducer.loading);
  //   setDataForView(data);

  //   data.map((vin) => {
  //     let des = vin?.itemDescription;
  //     let len = desLength;
  //     const formatDate = new Date(vin.cd);
  //     const vinInfo = {
  //       station: vin.station,
  //       stationOrder: vin.stationOrder,
  //       locationId: vin.stationCode,
  //       // itemCode: vin.itemCode,
  //       itemCode: vin.itemCode ? `${vin.itemCode}` : "",
  //       itemDescription: `${des ? des.substring(0, len) : ""}`,
  //       reqQty: vin.requiredQty,
  //       uom: vin.uom,
  //       createdDate: format(
  //         addMinutes(formatDate, formatDate.getTimezoneOffset()),
  //         "dd/MM/yyyy hh:mm aaa"
  //       ),
  //       cd: vin.cd,
  //       action: (
  //         <>
  //           {deleteStationMapping && (
  //             <DeleteButton
  //               tooltip="Delete"
  //               variant="gradient"
  //               color="error"
  //               iconOnly
  //               type="button"
  //               style={{ marginRight: "5px" }}
  //               onClick={() => handleOpenDeleteModal(vin)}
  //             >
  //               <Icon>delete</Icon>
  //             </DeleteButton>
  //           )}
  //         </>
  //       ),
  //     };
  //     tempVin.push(vinInfo);
  //   });

  //   setViewTable({ ...vinTable, rows: tempVin });
  // }, [getItemMasterReducer]);

  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleOpenDeleteModal = (data) => {
    setOpenDeleteModal(true);
    setSingleDataForDelete(data);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };
  const [isErrorDelete, setIsErrorDelete] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState(false);
  const [isSuccessForDelete, setIsSuccessForDelete] = useState(false);

  useEffect(() => {
    if (isErrorDelete) {
      setTimeout(() => {
        setIsErrorDelete(false);
      }, 3000);
    }
  }, [isErrorDelete]);
  useEffect(() => {
    if (isSuccessForDelete) {
      setTimeout(() => {
        setIsSuccessForDelete(false);
      }, 2000);
    }
  }, [isSuccessForDelete]);

  const [singleDataForFgDelete, setSingleDataForFgDelete] = useState({});
  const [openFgDeleteModal, setOpenFgDeleteModal] = useState(false);

  const handleOpenFgDeleteModal = (data) => {
    setOpenFgDeleteModal(true);
    setSingleDataForFgDelete(data);
  };

  const handleCloseFgDeleteModal = () => {
    setOpenFgDeleteModal(false);
  };
  const [isErrorForFgDelete, setIsErrorForFgDelete] = useState(false);
  const [errorMsgForDeleteForFg, setErrorMsgForDeleteForFg] = useState(false);
  const [isSuccessForDeleteForFg, setIsSuccessForDeleteForFg] = useState(false);

  useEffect(() => {
    if (isErrorForFgDelete) {
      setTimeout(() => {
        setIsErrorForFgDelete(false);
      }, 3000);
    }
  }, [isErrorForFgDelete]);
  useEffect(() => {
    if (isSuccessForDeleteForFg) {
      setTimeout(() => {
        setIsSuccessForDeleteForFg(false);
      }, 2000);
    }
  }, [isSuccessForDeleteForFg]);

  const [deleteFgButtonName, setDeleteFgButtonName] = useState("Delete");

  const deleteFg = async () => {
    setDeleteFgButtonName("Please wait...");
    let fgId = singleDataForFgDelete.fgModelId;

    let userId = loginDetails.data.userId;

    let res = await deleteFgForBom(fgId, userId);

    if (res.status) {
      await getBomForPo(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseFgDeleteModal();
        setDeleteFgButtonName("Delete");
      }, 3000);
      setIsSuccessForDeleteForFg(true);
    }
    if (!res.status) {
      setIsErrorForFgDelete(true);
      setDeleteFgButtonName("Delete");
      setErrorMsgForDeleteForFg(res?.data?.data?.msg);
    }
  };
  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteItemBom = async () => {
    setDeleteButtonName("Please wait...");
    let bomId = singleDataForDelete.bomId;
    let userId = loginDetails.data.userId;
    let res = await deleteBom(bomId, userId);
    if (res.status) {
      await getItemMaster(jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 3000);
      setIsSuccessForDelete(true);
    }
    if (!res.status) {
      setIsErrorDelete(true);
      setErrorMsgForDelete(res?.data?.data?.msg);
      setDeleteButtonName("Delete");
    }
  };

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);

  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };

  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    let data = new FormData();

    data.append("userId", userId);
    data.append("file", uploadCsvData);

    let res = await uploadForBomForPo(data, jwtToken);

    if (res.status) {
      getBomForPo(pageNo, rowsPerPage, searchObject, jwtToken);
      setUploadCsvFilter(false);
      DataUploadSuccessNotification();
    }
    if (!res.status) {
      DataUploadFailureNotification(res?.data?.data?.msg);
    }
  };

  const headersForTemp = [
    {
      label: "sequence",
      key: "sequence",
    },
    {
      label: "poNumber",
      key: "poNumber",
    },
    {
      label: "itemCode",
      key: "itemCode",
    },
    { label: "qty", key: "qty" },
    { label: "serialNumber", key: "serialNumber" },
  ];

  const headers = [
    {
      label: "poNumber",
      key: "poNumber",
    },
    {
      label: "itemCode",
      key: "itemCode",
    },
    { label: "serialNumber", key: "serialNumber" },
  ];
  // const csvLink3 = {
  //   filename: "BOM Data.csv",
  //   headers: headers,
  //   data: dataForDownload,
  // };
  const csvLink = {
    filename: "BOM Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const headersForView = [
    // {
    //   label: "fgCode",
    //   key: "fgCode",
    // },
    {
      label: "station",
      key: "station",
    },
    { label: "stationOrder", key: "stationOrder" },
    { label: "itemCode", key: "itemCode" },
    { label: "itemDescription", key: "itemDescription" },
    { label: "requiredQty", key: "reqQty" },
    // { label: "createdDate", key: "createdDate" },
  ];

  // const csvLink = {
  //   filename: "BOM Template.csv",
  //   headers: headersForView,
  //   data: [],
  // };
  const csvLink2 = {
    filename: "BOM Data.csv",
    headers: headersForView,
    data: itemRows,
  };

  const [createBomForPoModal, setCreateBomModal] = useState(false);
  const handleCreateBomModal = () => {
    setIsFlagMode(false);
    setCreateBomModal(true);
  };
  const handleOpenAddModal = () => {
    setIsFlagMode(true);
    setCreateBomModal(true);
  };
  const handleCloseCreateBomModal = () => {
    setCreateBomModal(false);
    setSelectedFgCode("");
    setSelectedAssemblyTypeForHeader("");
    setAssembly("");
  };

  const [flagForAssembly, setFlagForAssembly] = useState(false);

  const initialValuesForBom = {
    fgModelId: "",
    itemsForBom: [
      {
        itemId: "",
        qty: "",
      },
    ],
  };

  const [buttonName, setButtonName] = useState("Submit");

  const onSubmitForCreateBom = async (values, { resetForm }) => {
    setButtonName("Please wait...");
    let payload;

    payload = {
      poNumber: selectedAssemblyTypeForHeader?.label,
      poId: selectedAssemblyTypeForHeader?.value,
      operation: values.itemsForBom,
      userId: userId,
    };

    let res = await createBomForPo(payload, jwtToken);
    if (res.status) {
      getBomForPo(pageNo, rowsPerPage, searchObject, jwtToken);
      setIsSuccessForCreateBOM(true);
      setAssembly("");
      resetForm();
      setTimeout(() => {
        handleCloseCreateBomModal();
        setButtonName("Submit");
      }, 3000);
    } else {
      setErrorMsgForCreate(res?.data?.data?.msg);
      setIsErrorForCreateBOM(true);
      setButtonName("Submit");
    }
  };

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getBomForPo(pageNo, rowsPerPage, searchObject, jwtToken);

      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox color="text" px={2} mt={4}>
                {createBomForPoAccess && (
                  <CreateButton
                    tooltip="Create BOM"
                    // disabled={!createAccess}
                    color="info"
                    variant="contained"
                    type="button"
                    iconOnly
                    onClick={() => {
                      handleCreateBomModal();
                      getFgCode(jwtToken);
                    }}
                    style={{ marginRight: "1rem" }}
                  >
                    <Icon>add</Icon>
                  </CreateButton>
                )}
                {uploadBom && (
                  <UploadButton
                    tooltip="Upload CSV"
                    //   disabled={!uploadItem}
                    style={{ marginRight: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="info"
                    iconOnly
                    onClick={uploadCsvFilterHandler}
                  >
                    <Icon>upload</Icon>
                  </UploadButton>
                )}

                {downloadBom && (
                  <CSVLink {...csvLink}>
                    <DownloadButton
                      tooltip="Download Template"
                      style={{ marginRight: "1rem" }}
                      type="button"
                      variant="outlined"
                      color="error"
                      iconOnly
                    >
                      <Icon>download</Icon>
                    </DownloadButton>
                  </CSVLink>
                )}

                {/* <CSVLink {...csvLink3}>
                  <DownloadDataButton
                    tooltip="Download BOM Data"
                    style={{ marginRight: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="success"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadDataButton>
                </CSVLink> */}
              </MDBox>
              {uploadCsvFilter && (
                <div style={{ marginLeft: "1", marginTop: "0.5rem" }}>
                  <div>
                    <input
                      className="choose_file"
                      style={{
                        marginTop: "1.5rem",
                        marginLeft: "1.5rem",
                        // marginBottom: "-9rem",
                      }}
                      type="file"
                      accept=".csv"
                      onChange={(e) => {
                        setUploadCsvData(e.target.files[0]);
                      }}
                    />
                    <MDButton
                      disabled={
                        !uploadCsvData?.name ||
                        uploadCsvData?.type !== "text/csv"
                      }
                      variant="contained"
                      color="info"
                      style={{ marginLeft: "0", marginTop: "0rem" }}
                      type="button"
                      onClick={uploadCsvHandler}
                    >
                      UPLOAD
                    </MDButton>
                  </div>
                  <div style={{ marginBottom: "-20px" }}>
                    <span
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginLeft: "30px",
                        fontStyle: "italic",
                      }}
                    >
                      <strong>*</strong> Please upload
                      <strong>".csv"</strong> file only
                    </span>
                  </div>
                </div>
              )}
              <MDBox pt={3}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    options={{ draggable: false }}
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>
              <Modal
                open={openUpdateModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForEdit}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Update
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForUpdate.handleSubmit}
                    >
                      <MDBox mb={2}>
                        <MDTypography variant="h6">QTY</MDTypography>
                        <MDInput
                          type="number"
                          name="reqQty"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForUpdate.handleBlur}
                          onChange={formikForUpdate.handleChange}
                          value={formikForUpdate.values.reqQty}
                          error={
                            formikForUpdate.touched.reqQty &&
                            formikForUpdate.errors.reqQty &&
                            true
                          }
                          inputProps={{
                            maxLength: 45,
                          }}
                        />
                        {formikForUpdate.touched.reqQty &&
                          formikForUpdate.errors.reqQty && (
                            <TextError msg={formikForUpdate.errors.reqQty} />
                          )}
                      </MDBox>

                      <MDBox>
                        <Collapse in={isErrorForUpdate}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsgForUpdate}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessForUpdate}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Updated successfully
                          </Alert>
                        </Collapse>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDButton
                          variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          // disabled={!formikForUpdate.isValid}
                        >
                          Submit
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={viewModal}
                onClose={handleCloseViewModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard
                  sx={dataForView.length < 3 ? styleForView : styleForView2}
                >
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      FG Code: {fgModelCode}
                    </MDTypography>
                    <MDBox></MDBox>
                    <MDBox>
                      <span>
                        <Tooltip title="Close">
                          <IconButton
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                              marginBottom: "5px",
                            }}
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseViewModal}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </span>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginBottom: "1rem" }} />
                  <MDBox>
                    {!loading2 ? (
                      <>
                        <CSVLink {...csvLink2}>
                          <DownloadDataButton
                            tooltip="Download BOM Data"
                            style={{ marginLeft: "3rem" }}
                            type="button"
                            variant="outlined"
                            color="success"
                            iconOnly
                          >
                            <Icon>download</Icon>
                          </DownloadDataButton>
                        </CSVLink>
                        <DataTable
                          table={{ columns: itemColumns, rows: itemRows }}
                          isSorted={true}
                          tableSearch={true}
                          entriesPerPage={{
                            defaultValue: 5,
                            entries: [5, 10, 15, 20, 25, 30],
                          }}
                          showTotalEntries={true}
                          noEndBorder
                          hideColumns={["cd"]}
                        />
                      </>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "100px",
                          marginBottom: "100px",
                        }}
                      >
                        <CircularProgress color="info" />
                      </div>
                    )}
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openDeleteModal}
                onClose={handleCloseDeleteModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={deleteStyle}>
                  <MDTypography>Are you sure you want to delete?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      color="info"
                      variant="outlined"
                      onClick={handleCloseDeleteModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ marginLeft: "0.5rem" }}
                      color="error"
                      onClick={deleteItemBom}
                      disabled={deleteButtonName === "Please wait..."}
                    >
                      {deleteButtonName}
                    </MDButton>
                    <MDBox mt={2}>
                      <Collapse in={isErrorDelete}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorDelete(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {errorMsgForDelete}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessForDelete}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessForDelete(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Deleted Successfully
                        </Alert>
                      </Collapse>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openFgDeleteModal}
                onClose={handleCloseFgDeleteModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={deleteStyle}>
                  <MDTypography>Are you sure you want to delete?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      color="info"
                      variant="outlined"
                      onClick={handleCloseFgDeleteModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ marginLeft: "0.5rem" }}
                      color="error"
                      onClick={deleteFg}
                      disabled={deleteFgButtonName === "Please wait..."}
                    >
                      {deleteFgButtonName}
                    </MDButton>
                    <MDBox mt={2}>
                      <Collapse in={isErrorForFgDelete}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForFgDelete(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {errorMsgForDeleteForFg}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessForDeleteForFg}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessForDeleteForFg(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Deleted Successfully
                        </Alert>
                      </Collapse>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={createBomForPoModal}
                onClose={handleCloseCreateBomModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForCreateBom}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      {isFlagMode ? "Update BOM" : "Create BOM"}
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseCreateBomModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox>
                      <MDBox>
                        <Grid container>
                          <Formik
                            initialValues={initialValuesForBom}
                            validationSchema={validationSchemaForBom}
                            onSubmit={onSubmitForCreateBom}
                          >
                            {(formik) => {
                              return (
                                <Form>
                                  <div>
                                    <MDBox>
                                      {isFlagMode && (
                                        <MDBox
                                          display="flex"
                                          flexDirection="column"
                                          alignItems="flex-start"
                                          borderRadius={4}
                                          bgcolor="#f5f5f5"
                                          boxShadow={1}
                                          padding={0.5}
                                        >
                                          <MDTypography
                                            variant="h5"
                                            style={{
                                              fontWeight: "500",
                                              color: "#333",
                                              marginBottom: 4,
                                            }}
                                          >
                                            <span
                                              style={{ fontWeight: "bold" }}
                                            >
                                              FG Code:
                                            </span>{" "}
                                            {fgCodeForFlag}
                                          </MDTypography>
                                          <MDTypography
                                            variant="h5"
                                            style={{
                                              fontWeight: "500",
                                              color: "#333",
                                              marginBottom: 4,
                                            }}
                                          >
                                            <span
                                              style={{ fontWeight: "bold" }}
                                            >
                                              Assembly:
                                            </span>{" "}
                                            {selectedAssembly}
                                          </MDTypography>
                                          <MDTypography
                                            variant="h5"
                                            style={{
                                              fontWeight: "500",
                                              color: "#333",
                                            }}
                                          >
                                            <span
                                              style={{ fontWeight: "bold" }}
                                            >
                                              Assembly Type:
                                            </span>{" "}
                                            {selectedAssemblyType}
                                          </MDTypography>
                                        </MDBox>
                                      )}

                                      {isFlagMode ? (
                                        ""
                                      ) : (
                                        <Grid container spacing={2}>
                                          <Grid item xs={12} sm={4}>
                                            <MDBox
                                              mb={1}
                                              style={{ width: "310px" }}
                                            >
                                              <MDTypography variant="h6">
                                                PO Number
                                              </MDTypography>

                                              <Select
                                                isClearable
                                                className="select-css"
                                                maxMenuHeight={130}
                                                placeholder="Choose one..."
                                                name="assemblyType"
                                                onBlur={() => {
                                                  formik.handleBlur({
                                                    target: {
                                                      name: "assemblyType",
                                                    },
                                                  });
                                                }}
                                                value={
                                                  selectedAssemblyTypeForHeader
                                                }
                                                options={
                                                  assemblyTypesOptionsForHeader
                                                }
                                                onChange={(selectedOption) => {
                                                  handleAssemblyTypeForHeaderChange(
                                                    selectedOption,
                                                  );
                                                  formik.setFieldValue(
                                                    "assemblyType",
                                                    selectedOption,
                                                  );
                                                  getOperationsByPo(
                                                    selectedOption.value,
                                                    jwtToken,
                                                  );
                                                }}
                                              />

                                              {formik.touched.assemblyType &&
                                                formik.errors.assemblyType && (
                                                  <TextError
                                                    msg={
                                                      formik.errors.assemblyType
                                                    }
                                                  />
                                                )}
                                            </MDBox>
                                          </Grid>
                                        </Grid>
                                      )}
                                    </MDBox>
                                    <MDBox>
                                      <MDTypography variant="h5" mt={2}>
                                        Operations
                                      </MDTypography>
                                      <hr style={{ marginBottom: "10px" }} />

                                      <FieldArray name="itemsForBom">
                                        {(fieldArrayProps) => {
                                          const { push, remove, form } =
                                            fieldArrayProps;
                                          const { values } = form;
                                          const { itemsForBom } = values;
                                          setItemsForBomLength(
                                            itemsForBom.length,
                                          );

                                          return (
                                            <div>
                                              {itemsForBom.map(
                                                (item, index) => {
                                                  const isAddButtonDisabled =
                                                    !item.itemId || !item.qty;
                                                  return (
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                      key={index}
                                                    >
                                                      <Grid
                                                        container
                                                        spacing={2}
                                                      >
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          sm={3}
                                                        >
                                                          <MDBox
                                                            mb={1}
                                                            style={{
                                                              width: "100%",
                                                            }}
                                                          >
                                                            <MDTypography
                                                              variant="h6"
                                                              style={{
                                                                fontWeight:
                                                                  "500",
                                                              }}
                                                            >
                                                              Operation
                                                            </MDTypography>
                                                            <Select
                                                              menuPlacement="top"
                                                              menuPosition="absolute"
                                                              // isDisabled={
                                                              //   !formik.values
                                                              //     .assembly &&
                                                              //   !isFlagMode
                                                              // }
                                                              isClearable
                                                              className="select-css"
                                                              maxMenuHeight={
                                                                120
                                                              }
                                                              placeholder="Choose one..."
                                                              name={`itemsForBom[${index}].operation`}
                                                              onBlur={() => {
                                                                formik.handleBlur(
                                                                  {
                                                                    target: {
                                                                      name: `itemsForBom[${index}].operation`,
                                                                    },
                                                                  },
                                                                );
                                                              }}
                                                              options={
                                                                stationsOptions
                                                              }
                                                              value={
                                                                itemsForBom[
                                                                  index
                                                                ].operation
                                                              }
                                                              onChange={async (
                                                                selectedOption,
                                                              ) => {
                                                                formik.setFieldValue(
                                                                  `itemsForBom.${index}.operation`,
                                                                  selectedOption
                                                                    ? selectedOption
                                                                    : "",
                                                                );

                                                                const selectedItem =
                                                                  stationsOptions.find(
                                                                    (item) =>
                                                                      item.value ===
                                                                      selectedOption?.value,
                                                                  );
                                                                const stationOrder =
                                                                  selectedItem
                                                                    ? selectedItem.stationOrder
                                                                    : "";

                                                                formik.setFieldValue(
                                                                  `itemsForBom.${index}.operationId`,
                                                                  selectedOption
                                                                    ? selectedOption.value
                                                                    : "",
                                                                );
                                                                formik.setFieldValue(
                                                                  `itemsForBom.itemId`,
                                                                  selectedOption
                                                                    ? selectedOption.value
                                                                    : "",
                                                                );
                                                                if (
                                                                  selectedOption
                                                                ) {
                                                                  const res =
                                                                    await getItemsForBom(
                                                                      selectedOption.value,
                                                                      formik
                                                                        .values
                                                                        .itemsForBom,
                                                                      jwtToken,
                                                                    );
                                                                }
                                                              }}
                                                            />
                                                            {formik.touched
                                                              .itemsForBom &&
                                                              formik.errors
                                                                .itemsForBom &&
                                                              formik.errors
                                                                .itemsForBom[
                                                                index
                                                              ] &&
                                                              formik.errors
                                                                .itemsForBom[
                                                                index
                                                              ].operation && (
                                                                <TextError
                                                                  msg={
                                                                    formik
                                                                      .errors
                                                                      .itemsForBom[
                                                                      index
                                                                    ].operation
                                                                  }
                                                                />
                                                              )}
                                                          </MDBox>
                                                        </Grid>

                                                        <Grid
                                                          item
                                                          xs={12}
                                                          sm={2.5}
                                                          mr={4}
                                                        >
                                                          <MDBox
                                                            mb={1}
                                                            style={{
                                                              width: "100%",
                                                            }}
                                                          >
                                                            <MDTypography
                                                              variant="h6"
                                                              style={{
                                                                fontWeight:
                                                                  "500",
                                                              }}
                                                            >
                                                              Item Code/Des
                                                            </MDTypography>
                                                            <Select
                                                              isClearable
                                                              className="select-css-for-itemcode"
                                                              maxMenuHeight={
                                                                230
                                                              }
                                                              menuPlacement="top"
                                                              menuPosition="absolute"
                                                              placeholder="Choose one..."
                                                              name={`itemsForBom[${index}].itemId`}
                                                              onBlur={() => {
                                                                formik.handleBlur(
                                                                  {
                                                                    target: {
                                                                      name: `itemsForBom[${index}].itemId`,
                                                                    },
                                                                  },
                                                                );
                                                              }}
                                                              options={
                                                                itemCodeOptions
                                                              }
                                                              value={
                                                                itemsForBom[
                                                                  index
                                                                ].itemId
                                                              }
                                                              // isDisabled={
                                                              //   !formik.values
                                                              //     .itemsForBom[
                                                              //     index
                                                              //   ].operationCode
                                                              // } // Disable if stationId is not selected
                                                              onChange={(
                                                                selectedOption,
                                                              ) => {
                                                                formik.setFieldValue(
                                                                  `itemsForBom.${index}.itemId`,
                                                                  selectedOption
                                                                    ? selectedOption
                                                                    : "",
                                                                );

                                                                formik.setFieldValue(
                                                                  `itemsForBom.${index}.itemCode`,
                                                                  selectedOption
                                                                    ? selectedOption.value
                                                                    : "",
                                                                );
                                                              }}
                                                            />
                                                            {formik.touched
                                                              .itemsForBom &&
                                                              formik.errors
                                                                .itemsForBom &&
                                                              formik.errors
                                                                .itemsForBom[
                                                                index
                                                              ] &&
                                                              formik.errors
                                                                .itemsForBom[
                                                                index
                                                              ].itemId && (
                                                                <TextError
                                                                  msg={
                                                                    formik
                                                                      .errors
                                                                      .itemsForBom[
                                                                      index
                                                                    ].itemId
                                                                  }
                                                                />
                                                              )}
                                                          </MDBox>
                                                        </Grid>

                                                        <Grid
                                                          item
                                                          xs={12}
                                                          sm={1.5}
                                                          ml={7}
                                                        >
                                                          <MDBox mb={1}>
                                                            <MDTypography
                                                              variant="h6"
                                                              style={{
                                                                fontWeight:
                                                                  "500",
                                                              }}
                                                            >
                                                              Qty
                                                            </MDTypography>
                                                            <Field
                                                              className="form-control"
                                                              type="number"
                                                              name={`itemsForBom[${index}].qty`}
                                                              fullWidth
                                                              autoComplete="off"
                                                              value={
                                                                formik.values
                                                                  .itemsForBom[
                                                                  index
                                                                ].qty
                                                              }
                                                              inputProps={{
                                                                style: {
                                                                  height:
                                                                    "14px",
                                                                  min: 0,
                                                                },
                                                                maxLength: 45,
                                                              }}
                                                            />
                                                            {formik.touched
                                                              .itemsForBom &&
                                                              formik.touched
                                                                .itemsForBom[
                                                                index
                                                              ] &&
                                                              formik.touched
                                                                .itemsForBom[
                                                                index
                                                              ].qty &&
                                                              formik.errors
                                                                .itemsForBom &&
                                                              formik.errors
                                                                .itemsForBom[
                                                                index
                                                              ] &&
                                                              formik.errors
                                                                .itemsForBom[
                                                                index
                                                              ].qty && (
                                                                <TextError
                                                                  msg={
                                                                    formik
                                                                      .errors
                                                                      .itemsForBom[
                                                                      index
                                                                    ].qty
                                                                  }
                                                                />
                                                              )}
                                                          </MDBox>
                                                        </Grid>
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          sm={2}
                                                          ml={2.5}
                                                        >
                                                          <MDBox mb={1}>
                                                            <MDTypography
                                                              variant="h6"
                                                              style={{
                                                                fontWeight:
                                                                  "500",
                                                              }}
                                                            >
                                                              Serial Number
                                                            </MDTypography>
                                                            <Field
                                                              className="form-control"
                                                              type="number"
                                                              name={`itemsForBom[${index}].serialNumber`}
                                                              fullWidth
                                                              autoComplete="off"
                                                              value={
                                                                formik.values
                                                                  .itemsForBom[
                                                                  index
                                                                ].serialNumber
                                                              }
                                                              inputProps={{
                                                                style: {
                                                                  height:
                                                                    "14px",
                                                                  min: 0,
                                                                },
                                                                maxLength: 45,
                                                              }}
                                                            />
                                                            {formik.touched
                                                              .itemsForBom &&
                                                              formik.touched
                                                                .itemsForBom[
                                                                index
                                                              ] &&
                                                              formik.touched
                                                                .itemsForBom[
                                                                index
                                                              ].serialNumber &&
                                                              formik.errors
                                                                .itemsForBom &&
                                                              formik.errors
                                                                .itemsForBom[
                                                                index
                                                              ] &&
                                                              formik.errors
                                                                .itemsForBom[
                                                                index
                                                              ]
                                                                .serialNumber && (
                                                                <TextError
                                                                  msg={
                                                                    formik
                                                                      .errors
                                                                      .itemsForBom[
                                                                      index
                                                                    ]
                                                                      .serialNumber
                                                                  }
                                                                />
                                                              )}
                                                          </MDBox>
                                                        </Grid>

                                                        <span
                                                          style={{
                                                            display: "flex",
                                                            marginTop: "2.5rem",
                                                            marginLeft: "1rem",
                                                          }}
                                                        >
                                                          <div className="col">
                                                            {index > 0 && (
                                                              <CancelIcon
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                type="button"
                                                                className="secondary"
                                                                onClick={() =>
                                                                  remove(index)
                                                                }
                                                                color="error"
                                                              />
                                                            )}
                                                          </div>
                                                          {index ===
                                                            itemsForBom.length -
                                                              1 && (
                                                            <div>
                                                              <Tooltip title="Add Items">
                                                                <AddCircleIcon
                                                                  fontSize="large"
                                                                  onClick={() => {
                                                                    if (
                                                                      !isAddButtonDisabled
                                                                    ) {
                                                                      push({
                                                                        itemId:
                                                                          "",
                                                                        qty: "",
                                                                      });
                                                                      // setIsZoneFieldDisabled(
                                                                      //   true
                                                                      // );
                                                                    }
                                                                  }}
                                                                  color="info"
                                                                  style={{
                                                                    width:
                                                                      "30px",
                                                                    marginLeft:
                                                                      "0rem",
                                                                    cursor:
                                                                      isAddButtonDisabled
                                                                        ? "not-allowed"
                                                                        : "pointer",
                                                                    opacity:
                                                                      isAddButtonDisabled
                                                                        ? 0.5
                                                                        : 1,
                                                                  }}
                                                                />
                                                              </Tooltip>
                                                            </div>
                                                          )}
                                                        </span>
                                                      </Grid>
                                                    </div>
                                                  );
                                                },
                                              )}
                                            </div>
                                          );
                                        }}
                                      </FieldArray>
                                    </MDBox>

                                    <div style={{ background: "white" }}>
                                      <MDButton
                                        style={{
                                          position: "sticky",
                                          bottom: "0",
                                        }}
                                        color="info"
                                        fullWidth
                                        type="submit"
                                        disabled={
                                          !formik.isValid ||
                                          !selectedAssemblyTypeForHeader ||
                                          formik.values.itemsForBom.some(
                                            (item) => item.itemId === "",
                                          ) ||
                                          buttonName === "Please wait..."
                                        }
                                      >
                                        {buttonName}
                                      </MDButton>
                                    </div>
                                    <MDBox>
                                      <Collapse in={isErrorForCreateBOM}>
                                        <Alert
                                          severity="error"
                                          action={
                                            <IconButton
                                              aria-label="close"
                                              color="inherit"
                                              size="small"
                                              onClick={() => {
                                                setIsErrorForCreateBOM(false);
                                              }}
                                            >
                                              <CloseIcon fontSize="inherit" />
                                            </IconButton>
                                          }
                                        >
                                          {errorMsgForCreate}
                                        </Alert>
                                      </Collapse>
                                      <Collapse in={isSuccessForCreateBOM}>
                                        <Alert
                                          severity="success"
                                          action={
                                            <IconButton
                                              aria-label="close"
                                              color="inherit"
                                              size="small"
                                              onClick={() => {
                                                setIsSuccessForCreateBOM(false);
                                              }}
                                            >
                                              <CloseIcon fontSize="inherit" />
                                            </IconButton>
                                          }
                                        >
                                          Created Successfully
                                        </Alert>
                                      </Collapse>
                                    </MDBox>
                                  </div>
                                </Form>
                              );
                            }}
                          </Formik>
                        </Grid>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getBomForPoReducer: state.getBomForPoReducer,
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    itemMaster: state.itemMaster,
    getFgCodeReducer: state.getFgCodeReducer,
    getAssemblyMasterReducer: state.getAssemblyMasterReducer,
    getStationsByAssemblyIdForBomReducer:
      state.getStationsByAssemblyIdForBomReducer,

    getItemForBomReducer: state.getItemForBomReducer,
    getFgCodeByAssemblyTypeReducer: state.getFgCodeByAssemblyTypeReducer,
    getAssemblyByAssemblyTypeReducer: state.getAssemblyByAssemblyTypeReducer,
    getAssemblyTypesReducer: state.getAssemblyTypesReducer,
    getOperationsByPoReducer: state.getOperationsByPoReducer,
    getDownloadBomDataReducer: state.getDownloadBomDataReducer,
    getPoListingWithoutPaginationReducer:
      state.getPoListingWithoutPaginationReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getBomForPo: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getBomForPo(pageNo, rowsPerPage, searchObject, jwtToken)),
    getItemsForBom: (stationId, jwtToken) =>
      dispatch(getItemsForBom(stationId, jwtToken)),
    deleteBom: (stationId, userId, jwtToken) =>
      dispatch(deleteBom(stationId, userId, jwtToken)),
    createBomForPo: (payload, jwtToken) =>
      dispatch(createBomForPo(payload, jwtToken)),
    getFgCode: (jwtToken) => dispatch(getFgCode(jwtToken)),
    editBom: (payload, jwtToken) => dispatch(editBom(payload, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    uploadForBomForPo: (payload, jwtToken) =>
      dispatch(uploadForBomForPo(payload, jwtToken)),
    getStationsByAssemblyIdForBom: (assemblyId, jwtToken) =>
      dispatch(getStationsByAssemblyIdForBom(assemblyId, jwtToken)),
    getAssemblyMaster: (jwtToken) => dispatch(getAssemblyMaster(jwtToken)),

    getFgCodeByAssemblyType: (assemblyType, jwtToken) =>
      dispatch(getFgCodeByAssemblyType(assemblyType, jwtToken)),
    getAssemblyByAssemblyType: (assemblyType, jwtToken) =>
      dispatch(getAssemblyByAssemblyType(assemblyType, jwtToken)),
    deleteFgForBom: (fgId, userId, jwtToken) =>
      dispatch(deleteFgForBom(fgId, userId, jwtToken)),
    getAssemblyTypes: (jwtToken) => dispatch(getAssemblyTypes(jwtToken)),
    getDownloadBomData: (jwtToken) => dispatch(getDownloadBomData(jwtToken)),
    getOperationsByPo: (poId, jwtToken) =>
      dispatch(getOperationsByPo(poId, jwtToken)),
    getPoListingWithoutPagination: (jwtToken) =>
      dispatch(getPoListingWithoutPagination(jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BOMW);
